import React from "react";
import { Link } from "react-router-dom";
import { resolvePublicUploadUrl } from "../../../api/apiConfig/apiConfig";
import { WALLET_FALLBACK_ICON, fallbackCoinImg } from "./walletPageUiConstants";

/**
 * Spot vs unified wallets share the same table columns; behavior differs only in mobile sheet kind and action cells.
 */
export default function WalletFundsDataRow({
  item,
  spotStyleActions,
  onOpenMobileSheet,
  popupKind,
  safeRound,
  totalWalletQty,
  approxUsdLine,
  usdApproxFromPrice,
  spotUsdPriceLabel,
  handleSpotTransferClick,
  renderActionButtons,
}) {
  return (
    <tr>
      <td data-label="Coin">
        <div className="funding-account__coin flex-grow-1">
          <img
            className="funding-account__coin-img"
            src={item?.icon_path ? resolvePublicUploadUrl(item.icon_path) : WALLET_FALLBACK_ICON}
            alt=""
            onError={fallbackCoinImg}
          />
          <div>
            <div className="funding-account__coin-sym">{item?.short_name}</div>
            <div className="funding-account__coin-name">{item?.currency}</div>
          </div>
        </div>
      </td>
      <td className="ta-r agce-ao-total-balance-cell" data-label="Total Amount">
        <div className="d-flex align-items-center justify-content-end gap-2 agce-ao-mobile-total-with-more">
          <div className="agce-ao-balance-stack funding-account__num-stack">
            <div className="funding-account__num agce-ao-balance-stack__main">{safeRound(totalWalletQty(item))}</div>
            <div className="funding-account__subnum">{approxUsdLine(item)}</div>
          </div>
          <button
            type="button"
            className="agce-ao-more-btn d-inline-flex d-lg-none flex-shrink-0"
            aria-label="View full row"
            onClick={() => onOpenMobileSheet(popupKind, item)}
          >
            <i className="ri-more-2-fill" aria-hidden="true" />
          </button>
        </div>
      </td>
      <td className="ta-r" data-label="Available">
        <div className="funding-account__num">{safeRound(item?.balance)}</div>
        <div className="funding-account__subnum">{usdApproxFromPrice(item?.balance, item)}</div>
      </td>
      <td className="ta-r" data-label="In Order">
        <div className="funding-account__num">{safeRound(item?.locked_balance)}</div>
        <div className="funding-account__subnum">{usdApproxFromPrice(item?.locked_balance, item)}</div>
      </td>
      <td className="ta-r" data-label="Avg. Cost Price">
        <div className="funding-account__num">{spotUsdPriceLabel(item)}</div>
      </td>
      <td className="ta-r" data-label="Action">
        <div className="funding-account__actions">
          {spotStyleActions ? (
            <>
              {/* <Link to="/convert" className="funding-account__action">
                Convert
              </Link> */}
              <Link to={`/trade/${item?.short_name}_USDT`} className="funding-account__action">
                Trade
              </Link>
              <button
                type="button"
                className="funding-account__action funding-account__action--btn"
                data-bs-toggle="modal"
                data-bs-target="#walletTransferModal"
                onClick={handleSpotTransferClick(item)}
              >
                Transfer
              </button>
            </>
          ) : (
            renderActionButtons(item)
          )}
        </div>
      </td>
    </tr>
  );
}
